import React, { useEffect, useMemo, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { loadCompanies as loadCompaniesApi } from '../../api'
import { mergeCompanyRequest as mergeCompanyRequestAction } from '../../slices/company_request_slice'
import Table from './Table'

export default function MergeCompanyForm({ id, request }) {
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const company = useMemo(() => {
    if (!request) return

    return request.company_alias.company
  }, [request])

  useEffect(() => {
    if (!company) return

    handleSearch({ query: company.name })
  }, [company])

  const handleSearch = async (data) => {
    const payload = { ...data, status: 'approved' }
    setLoading(true)
    try {
      const res = await loadCompaniesApi(payload)
      setCompanies(res.data.companies)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const onSubmitMerge = (data) => {
    const params = {
      company_request: {
        primary_id: data.company_id,
      },
    }
    dispatch(mergeCompanyRequestAction({ data: params, id: request.id }))
  }

  return (
    <>
      <div className="dome-d-flex dome-flex-column">
        <div>
          <label>name</label>
          <p>{company?.name}</p>
        </div>
        <div>
          <label>company type</label>
          <p>{company?.company_type}</p>
        </div>
        <div>
          <label>status</label>
          <p>{company?.status}</p>
        </div>
      </div>
      <SearchForm onSubmitSearch={handleSearch} />
      <MergeForm id={id} companies={companies} onSubmitMerge={onSubmitMerge} loading={loading} />
    </>
  )
}

const SearchForm = ({ onSubmitSearch }) => {
  const { mergeCompanyRequestModalVisibility } = useSelector((state) => state.companyRequest)

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
  } = useForm({ query: null })

  useEffect(() => {
    if (!mergeCompanyRequestModalVisibility) return

    reset()
  }, [mergeCompanyRequestModalVisibility])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitSearch)} id="search_companies_form">
        <div className="form-group">
          <label htmlFor="search_company" className="form-label">
            search for the relevant company if it is not already included in the list
          </label>
          <input
            type="text"
            className="form-control dome-input"
            placeholder="Search company"
            {...register('query')}
            id="search_company"
          ></input>
          <input type="submit" style={{ visibility: 'hidden' }}></input>
        </div>
      </form>
    </>
  )
}

const MergeForm = ({ id, companies = [], onSubmitMerge, loading }) => {
  const {
    errorsFromServer: { merge: serverErrors },
    mergeCompanyRequestModalVisibility,
  } = useSelector((state) => state.companyRequest)
  const methods = useForm({ defaultValues: { company_id: null } })
  const {
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    clearErrors,
  } = methods

  useEffect(() => {
    if (!mergeCompanyRequestModalVisibility) return

    reset()
    clearErrors()
  }, [mergeCompanyRequestModalVisibility])

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors).forEach((field) => {
        setError(field, {
          type: 'server',
          message: serverErrors[field].join(', '),
        })
      })
    }
  }, [serverErrors, setError])

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmitMerge)} id={id}>
          <div className="form-group" style={{ overflow: 'auto', maxHeight: '500px' }}>
            <Table companies={companies} loading={loading} />
          </div>
          {errors.company_id && (
            <p className="dome-color-red-alert">{`company to merge ${errors.company_id.message}`}</p>
          )}
          {errors.base && <p className="dome-color-red-alert">{errors.base.message}</p>}
        </form>
      </FormProvider>
    </>
  )
}
